import { MDSIconKind } from "@/mds/components/icon";
import { ThemeType } from "./theme-context";

export const THEME_LABEL: Record<ThemeType, string> = {
  [ThemeType.Harvest]: "Light",
  [ThemeType.HarvestMoon]: "Dark",
  [ThemeType.System]: "System",
};

export const THEME_ICON: Record<ThemeType, MDSIconKind> = {
  [ThemeType.Harvest]: MDSIconKind.SunBright,
  [ThemeType.HarvestMoon]: MDSIconKind.Moon,
  [ThemeType.System]: MDSIconKind.Desktop,
};
